export {default as StyledAbout} from './about.js'